module.exports = __webpack_public_path__ + "static/img/创新型.d6b0c30.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/创新型.jpg
// module id = oUNv
// module chunks = 1